import type {
  EventAction,
  EventHandler,
} from '@/redux/middleware/googleTagManager/types';

type DataLayerItem = {
  event?: string;
};

const INTERVAL = 16;

// @todo according to Ivonne we can switch from gtm.dom to gtm.start
export const wrappedFunctionToWaitForGtmDom = <
  Handler extends (...args: Array<any>) => any,
>(
  handler: Handler
): ((...args: Parameters<Handler>) => Promise<ReturnType<Handler>>) => {
  return (...args) =>
    new Promise((resolve) => {
      const interval = window.setInterval(() => {
        if (
          import.meta.env.MODE === 'test' ||
          import.meta.env.MODE === 'development' ||
          ('dataLayer' in window &&
            Array.isArray(window?.dataLayer) &&
            window?.dataLayer.find((o: DataLayerItem) => o.event === 'gtm.dom'))
        ) {
          clearInterval(interval);
          resolve(handler(...args));
        }
      }, INTERVAL);
    });
};

export const waitForGtmDomEvent = <Event, Payload>(
  handler: EventHandler<EventAction<Payload>, Event>
): EventHandler<EventAction<Payload>, Promise<Event>> => {
  return wrappedFunctionToWaitForGtmDom<
    EventHandler<EventAction<Payload>, Event>
  >(handler);
};
